<script>
    /** @type {import('../types.d').ReadableRace} */
    export let race;

    $: time = new Date($race[0].time).toString()
    $: prefix = $race[0].time.split('-')[0]
    // $:console.log($race)
  </script>

  <p style="margin:auto; max-width:650px; display:none">{prefix} - {time}</p>
  